import { Calendar } from 'lucide-react';
export enum ROLE {
  ADMIN = "Admin",
  EMPLOYEE = "Employee",
  CLIENT = "Client"
}

export enum ACTION {
  //Employee Actions
  CREATE_EMPLOYEE = "CREATE_EMPLOYEE",
  EDIT_EMPLOYEE = "EDIT_EMPLOYEE",
  VIEW_ALL_EMPLOYEES = "VIEW_ALL_EMPLOYEES",

  //Warehouse Actions
  CREATE_WAREHOUSE = "CREATE_WAREHOUSE",
  EDIT_WAREHOUSE = "EDIT_WAREHOUSE",
  DELETE_WAREHOUSE = "DELETE_WAREHOUSE",
  VIEW_ALL_WAREHOUSES = "VIEW_ALL_WAREHOUSES",

  //StorageUnit Actions
  CREATE_STORAGE_UNIT = "CREATE_STORAGE_UNIT",
  EDIT_STORAGE_UNIT = "EDIT_STORAGE_UNIT",
  DELETE_STORAGE_UNIT = "DELETE_STORAGE_UNIT",
  VIEW_ALL_STORAGE_UNITS = "VIEW_ALL_STORAGE_UNITS",

  //Supplier Actions
  CREATE_SUPPLIER = "CREATE_SUPPLIER",
  EDIT_SUPPLIER = 'EDIT_SUPPLIER',
  VIEW_ALL_SUPPLIERS = 'VIEW_ALL_SUPPLIERS',

  //Brand Actions
  CREATE_BRAND = "CREATE_BRAND",
  EDIT_BRAND = "EDIT_BRAND",
  VIEW_ALL_BRANDS = "VIEW_ALL_BRANDS",

  //Client Listing
  CREATE_CLIENT = "CREATE_CLIENT",
  EDIT_CLIENT = "EDIT_CLIENT",
  VIEW_ALL_CLIENTS = "VIEW_ALL_CLIENTS",

  //Shipment Actions
  CREATE_SHIPMENT = "CREATE_SHIPMENT",
  EDIT_SHIPMENT = "EDIT_SHIPMENT",
  RECEIVE_SHIPMENT = "RECEIVE_SHIPMENT",
  COMPLETE_SHIPMENT = "COMPLETE_SHIPMENT",
  VIEW_ALL_SHIPMENTS = "VIEW_ALL_SHIPMENTS",

//Box Actions

  //PRODUCT ACTIONS
  ADD_PRODUCT = "ADD_PRODUCT",
  EDIT_PRODUCT = "EDIT_PRODUCT",
  IMPORT_PRODUCTS = "IMPORT_PRODUCTS",
  VIEW_ALL_PRODUCTS = "VIEW_ALL_PRODUCS",

  //Client On Hand Actions
  SEE_CLIENT_ON_HAND = "SEE_CLIENT_ON_HAND"
}

class PermissionService {
  private static instance: PermissionService;

  private permissions: Record<ACTION, ROLE[]> = {
    //Employees Permissions
    [ACTION.CREATE_EMPLOYEE]: [ROLE.ADMIN],
    [ACTION.EDIT_EMPLOYEE]: [ROLE.ADMIN],
    [ACTION.VIEW_ALL_EMPLOYEES]: [ROLE.ADMIN],

    //Warehouse Permissions
    [ACTION.CREATE_WAREHOUSE]: [ROLE.ADMIN],
    [ACTION.EDIT_WAREHOUSE]: [ROLE.ADMIN],
    [ACTION.DELETE_WAREHOUSE]: [ROLE.ADMIN],
    [ACTION.VIEW_ALL_WAREHOUSES]: [ROLE.ADMIN, ROLE.EMPLOYEE],

    //StorageUnit Permissions
    [ACTION.CREATE_STORAGE_UNIT]: [ROLE.ADMIN],
    [ACTION.EDIT_STORAGE_UNIT]: [ROLE.ADMIN],
    [ACTION.DELETE_STORAGE_UNIT]: [ROLE.ADMIN],
    [ACTION.VIEW_ALL_STORAGE_UNITS]: [ROLE.ADMIN, ROLE.EMPLOYEE],

    //Supplier Permissions
    [ACTION.CREATE_SUPPLIER]: [ROLE.ADMIN],
    [ACTION.EDIT_SUPPLIER]: [ROLE.ADMIN],
    [ACTION.VIEW_ALL_SUPPLIERS]: [ROLE.ADMIN, ROLE.EMPLOYEE],

    //Brand Permissions
    [ACTION.CREATE_BRAND]: [ROLE.ADMIN],
    [ACTION.EDIT_BRAND]: [ROLE.ADMIN],
    [ACTION.VIEW_ALL_BRANDS]: [ROLE.ADMIN, ROLE.EMPLOYEE],

    //Client Permissions
    [ACTION.CREATE_CLIENT]: [ROLE.ADMIN],
    [ACTION.EDIT_CLIENT]: [ROLE.ADMIN],
    [ACTION.VIEW_ALL_CLIENTS]: [ROLE.ADMIN, ROLE.EMPLOYEE],

    //Shipment Permissions
    [ACTION.CREATE_SHIPMENT]: [ROLE.ADMIN, ROLE.EMPLOYEE],
    [ACTION.EDIT_SHIPMENT]: [ROLE.ADMIN, ROLE.EMPLOYEE],
    [ACTION.RECEIVE_SHIPMENT]: [ROLE.ADMIN, ROLE.EMPLOYEE],
    [ACTION.COMPLETE_SHIPMENT]: [ROLE.ADMIN, ROLE.EMPLOYEE],
    [ACTION.VIEW_ALL_SHIPMENTS]: [ROLE.ADMIN, ROLE.EMPLOYEE],

    //Product Permissions
    [ACTION.ADD_PRODUCT]: [ROLE.ADMIN, ROLE.EMPLOYEE],
    [ACTION.EDIT_PRODUCT]: [ROLE.ADMIN, ROLE.EMPLOYEE],
    [ACTION.IMPORT_PRODUCTS]: [ROLE.ADMIN, ROLE.EMPLOYEE],
    [ACTION.VIEW_ALL_PRODUCTS]: [ROLE.ADMIN, ROLE.EMPLOYEE],

    //Client On Hand Permissions
    [ACTION.SEE_CLIENT_ON_HAND]: [ROLE.CLIENT],

  };

  private constructor() {}

  public static getInstance(): PermissionService {
    if (!PermissionService.instance) {
      PermissionService.instance = new PermissionService();
    }
    return PermissionService.instance;
  }

  public isAllowed(action: ACTION, role: ROLE): boolean {
    const allowedRoles = this.permissions[action] || [];
    return allowedRoles.includes(role);
  }
}

export default PermissionService; 